import { render, staticRenderFns } from "./ringmaker.vue?vue&type=template&id=3b148e6d"
import script from "./ringmaker.vue?vue&type=script&lang=js"
export * from "./ringmaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports